function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { buildComponentName } from '../utils';
import SubMixin from './mixins/sub';
export default {
  name: buildComponentName('SelectSelector'),
  mixins: [SubMixin],
  props: {
    showArrow: {
      type: Boolean,
      default: false
    },
    selections: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    prefixCls: function prefixCls() {
      return this.rootPrefixCls;
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          rootSize = this.rootSize,
          rootInnerVisible = this.rootInnerVisible,
          rootIsCombobox = this.rootIsCombobox,
          rootDisabled = this.rootDisabled,
          rootAllowClear = this.rootAllowClear;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(rootSize === 'small' ? 'sm' : 'lg'), rootSize === 'large' || rootSize === 'small'), _defineProperty(_ref, "".concat(prefixCls, "-combobox"), rootIsCombobox), _defineProperty(_ref, "".concat(prefixCls, "-open"), rootInnerVisible), _defineProperty(_ref, "".concat(prefixCls, "-disabled"), rootDisabled), _defineProperty(_ref, "".concat(prefixCls, "-enable"), !rootDisabled), _defineProperty(_ref, "".concat(prefixCls, "-allow-clear"), rootAllowClear), _ref;
    },
    mode: function mode() {
      var rootIsMultiple = this.rootIsMultiple;
      return rootIsMultiple ? 'multiple' : 'single';
    },
    arrowNode: function arrowNode() {
      return this.renderArrow();
    },
    clearNode: function clearNode() {
      return this.renderClear();
    }
  },
  methods: {
    renderArrow: function renderArrow() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          showArrow = this.showArrow;
      return showArrow ? h("span", {
        "key": "arrow",
        "class": "".concat(prefixCls, "-arrow"),
        "style": {
          outline: 'none'
        }
      }, [h("b")]) : null;
    },
    renderClear: function renderClear() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          rootAllowClear = this.rootAllowClear,
          rootIsMultiple = this.rootIsMultiple,
          rootClearDisabled = this.rootClearDisabled,
          selections = this.selections,
          onSelectorClear = this.onSelectorClear;

      if (!rootAllowClear) {
        return null;
      }

      if (!rootClearDisabled) {
        if (rootIsMultiple && selections.every(function (v) {
          return !!v.disabled;
        })) {
          return null;
        }
      } else if (selections.length === 0) {
        return null;
      }

      return h("span", {
        "key": "clear",
        "class": "".concat(prefixCls, "-selection__clear"),
        "attrs": {
          "unselectable": "on"
        },
        "style": "user-select:none",
        "on": {
          "click": onSelectorClear,
          "mousedown": function mousedown(e) {
            return e.preventDefault();
          }
        }
      });
    }
  },
  render: function render() {
    var _selectionCls;

    var h = arguments[0];
    var $slots = this.$slots,
        prefixCls = this.prefixCls,
        classes = this.classes,
        mode = this.mode,
        arrowNode = this.arrowNode,
        clearNode = this.clearNode;
    var selectionCls = (_selectionCls = {}, _defineProperty(_selectionCls, "".concat(prefixCls, "-selection"), true), _defineProperty(_selectionCls, "".concat(prefixCls, "-selection--").concat(mode), mode), _selectionCls);
    return h("span", {
      "attrs": {
        "role": "combobox"
      },
      "class": classes
    }, [h("span", {
      "attrs": {
        "role": "selection"
      },
      "class": selectionCls
    }, [$slots.default, arrowNode, clearNode])]);
  }
};